<script setup>
import { ref, defineProps, onMounted } from 'vue';

const props = defineProps({
  reviewData: {
    type: Object,
  },
});
const userName = ref('');
const userGravatar = ref('');
const star = ref(4);
const content = ref('');
const checkIcon = (starNum, n) => {
  if (starNum >= n) {
    return 'star';
  }
  return 'grade';
};
onMounted(() => {
  star.value = props.reviewData.rating;
  content.value = props.reviewData.content;
  const userInfo = document.querySelector('#fedora-data');
  if (userInfo) {
    // eslint-disable-next-line prefer-destructuring
    userName.value = userInfo.dataset.name.split('@')[0];
    userGravatar.value = userInfo.dataset['gravatar-url'];
  }
});
</script>

<template>
  <div class="modal-body">
    <div class="mt-4 mb-2">
      <h4 class="text-center mb-3">
        <div class="d-inline-flex align-items-center">
          感謝您協助我們持續進步！
          <span class="material-icons-outlined align-middle ms-1"> mood </span>
        </div>
      </h4>
      <h5 class="text-center fw-normal">
        您的評價將在 24 小時內公開於課程平台。
      </h5>
      <div class="mx-auto" style="max-width: 460px">
        <div class="bg-hex-review-secondary rounded-2 mt-5 mb-4 p-3">
          <div class="d-flex align-items-center">
            <img
              :src="
                userGravatar ||
                'https://s.gravatar.com/avatar/4f3bd4380429c206fdd43aec0a6482e0?d=mm'
              "
              class="rounded-circle d-block me-2"
              alt=""
              style="width: 40px; height: 40px; object-fit: cover"
            />
            <div>
              <p class="mb-0" style="margin-left: 2px">{{ userName }}</p>
              <div class="d-flex justify-content-start">
                <span
                  v-for="n in 5"
                  :key="`star${n}`"
                  class="material-icons-outlined text-hex-review-primary"
                >
                  {{ checkIcon(star, n) }}
                </span>
              </div>
            </div>
          </div>
          <p class="mt-2 text-wrapper" style="margin-left: 50px">
            {{ content }}
          </p>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <button
          type="button"
          class="btn btn-hex-review-dark"
          @click="$emit('close')"
        >
          返回課程頁面
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
::v-deep .text-wrapper {
  white-space: pre-wrap;
}
</style>
